import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import SuccessfulPurchase from 'views/SuccessfulPurchase';
import { resolveWhatsappNumber } from 'helpers/whatsappOrderMessage';

const SuccessfulPurchaseContainer = (props) => {
  const {
    guideNumber,
    orderId,
    whatsappNumber,
    whatsappMessage,
  } = props;

  return (
    <SuccessfulPurchase
      guideNumber={guideNumber}
      orderId={orderId}
      whatsappNumber={whatsappNumber}
      whatsappMessage={whatsappMessage}
    />
  );
};

const mapStateToProps = (state, props) => {
  const lastCheckout = state.cart.lastCheckout;

  return {
    guideNumber: props.match?.params?.guideNumber,
    orderId: lastCheckout?.orderId,
    whatsappNumber: lastCheckout?.whatsappNumber
      || resolveWhatsappNumber({ whatsapp: state.app.whatsapp, client: state.app.client }),
    whatsappMessage: lastCheckout?.whatsappMessage,
  };
};

SuccessfulPurchaseContainer.propTypes = {
  guideNumber: PropTypes.string,
  orderId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  whatsappNumber: PropTypes.string,
  whatsappMessage: PropTypes.string,
};

SuccessfulPurchaseContainer.defaultProps = {
  guideNumber: null,
  orderId: null,
  whatsappNumber: null,
  whatsappMessage: null,
};

export default connect(mapStateToProps)(SuccessfulPurchaseContainer);
